import React from 'react'
import ArrowIcon from '@material-ui/icons/ArrowForward'
import ListItem from './ListItem';
import { withStyles } from '@material-ui/core';
import Tr from 'translations/Translations';

const style = theme => ({
	root: {
		paddingTop: 0,
		paddingBottom: 0,

		...theme.components.navigation.item.primary
	},
	icon: {
		fill: theme.palette.primary.contrastText
	}
})

function RolingElement({
	open,
	setOpen,
	setInnerMenuOpen,
	classes,
}) {
	const handleClick = () => {
		setOpen(!open)
		setInnerMenuOpen({})
	}
	return (
		<ListItem
			Icon={ArrowIcon}
			onClick={handleClick}
			iconPosition='right'
			open={open}
			className={classes.root}
			classesObj={{
				icon: classes.icon
			}}
			tooltip={open ? Tr('collapse') : Tr('expand')}
		/>
	)
}

export default withStyles(style)(RolingElement)
